import React, { useContext, useEffect, useRef, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import { FaRedoAlt, FaFilePdf } from "react-icons/fa"; // PDF icon
import { v4 as uuidv4 } from "uuid"; // For generating unique IDs
const apiUrl = process.env.REACT_APP_API_URL;
const apiImage = process.env.REACT_APP_MY_ID_IMAGE;

const translations = {
  en: {
    selectLanguage: "Select Language:",
    uploadTitle: "Upload fraudulent transactions",
    uploadNote: "Upload screenshots of all the fraudulent transactions.",
    chooseFiles: "Choose Files",
    ok: "OK",
    moveError:"Please answer the current question before proceeding to the next one.",
  },
  Hi: {
    selectLanguage: "भाषा चुनें:",
    uploadTitle: "धोखाधड़ी वाले लेनदेन अपलोड करें",
    uploadNote: "सभी धोखाधड़ी वाले लेनदेन के स्क्रीनशॉट अपलोड करें।",
    chooseFiles: "फ़ाइल चुनें",
    moveError:"कृपया अगले प्रश्न पर जाने से पहले वर्तमान प्रश्न का उत्तर दें।",
    ok: "ठीक है",
  },
  Kn: {
    selectLanguage: "ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ:",
    uploadTitle: "ವಂಚನೆಯ ವಹಿವಾಟುಗಳನ್ನು ಅಪ್‌ಲೋಡ್‌ ಮಾಡಿ.",
    uploadNote: "ಕಡ್ಡಾಯವಾಗಿ ವಂಚನೆಗೆ ಸಂಬಂಧಿಸಿದ ವಹಿವಾಟಿನ ಸ್ಕ್ರಿನ್‌ ಶಾಟ್‌ಗಳನ್ನು ಮತ್ತು ಇತರೆ ಪುರಾವೆಗಳನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡುವುದು.",
    chooseFiles: "ಫೈಲ್ ಆಯ್ಕೆ ಮಾಡಿ",
    ok: "ಸರಿ",
    moveError:"ದಯವಿಟ್ಟು ಮುಂದಿನ ಪ್ರಶ್ನೆಗೆ ಹೋಗುವ ಮೊದಲು ಪ್ರಸ್ತುತ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರ ನೀಡಿ.",
  },
};

const BankUpload = ({
  submitSupport,
  onNext,
  onQuestion,
  answer,
  apiKey,
  botToken,
  vist_id,
  app_ver,
  selectedLang
}) => {
  const [files, setFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isPlaying, setIsPlaying] = useState(false); // Audio play status
  const audioRef = useRef(null);
  const MAX_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB in bytes


      // Mapping language codes to audio source files
      const audioMap = {
        en: "audio/English BOT Audios/bankupload.mp3",
        Hi: "audio/Hindi BOT Audios/Hindi-Audio6.mp3",
        Kn: "audio/Kannada BOT Audios/Kannada-Audio6.m4a",
        tcy: "audio/cybervictim_tcy.mp3"
      };

  useEffect(() => {
    const storedFiles = localStorage.getItem("BankFile");
    if (storedFiles) {
      const parsedFiles = JSON.parse(storedFiles);
      setFiles(parsedFiles);
      submitSupport(parsedFiles);
    }
  }, []);

  const handleFileChange = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (files.length + selectedFiles.length > apiImage) {
      setErrorMessage(`You can only upload a maximum of ${apiImage} files.`);
      return;
    }

    let errorMessages = "";
    const validFiles = selectedFiles.filter((file) => {
      const isImageOrPdf =
        file.type.startsWith("image/") || file.type === "application/pdf";
      const isSizeValid = file.size <= MAX_UPLOAD_SIZE;
      if (!isImageOrPdf) errorMessages = "Only images or PDF files are allowed.";
      if (!isSizeValid) errorMessages = "File must be below 10MB.";
      return isImageOrPdf && isSizeValid;
    });

    setErrorMessage(errorMessages);

    if (!errorMessages) {
      const filesWithUrls = validFiles.map((file) => ({
        file,
        url: URL.createObjectURL(file),
        uuid: uuidv4(),
        name: file.name,
        type: file.type,
        status: "pending",
      }));

      localStorage.setItem("BankFile", JSON.stringify([...files, ...filesWithUrls]));
      submitSupport(filesWithUrls);
      setFiles((prevFiles) => [...prevFiles, ...filesWithUrls]);

      uploadFiles(filesWithUrls);
    }
  };

  const uploadFiles = async (validFiles) => {
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    try {
      setIsUploading(true);
      
      for (const { file, uuid } of validFiles) {
        const formData = new FormData();
        formData.append("api_key", apiKey);
        formData.append("visitor_token", vist_id);
        formData.append("qtion_id", "66f654783112a");
        formData.append("qtion_num", "4");
        formData.append("lac_token", botToken);
        formData.append("app_ver", app_ver);
        formData.append("userImage", file);
        formData.append("ref_id", uuid);
        formData.append("type", "1");

        const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_doc`, {
          method: "POST",
          body: formData,
        });
        const fileData = await response.json();
        if (fileData?.resp?.error_code === "0") {
          setFiles((prevFiles) =>
            prevFiles.map((f) => (f.uuid === uuid ? { ...f, status: "uploaded" } : f))
          );
          const updatedFiles = JSON.parse(localStorage.getItem("BankFile")).map((f) =>
            f.uuid === uuid ? { ...f, status: "uploaded" } : f
          );
          localStorage.setItem("BankFile", JSON.stringify(updatedFiles));
          submitSupport(updatedFiles);
        } else {
          setErrorMessage(fileData?.resp?.message);
          break;
        }
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    } finally {
      setIsUploading(false);
    }
  };

  const handleRemoveFile = async (index, uuid) => {
    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_remove_doc`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          api_key: apiKey,
          visitor_token: vist_id,
          qtion_id: "66f654783112a",
          qtion_num: "4",
          option_val: "670fce3010e33775926208",
          lac_token: botToken,
          app_ver: app_ver,
          ref_id: uuid,
          type: "1",
          bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
        }),
      });
      const result = await response.json();
      if (result.resp.error_code === "0") {
        setFiles((prevFiles) => prevFiles.filter((file) => file.uuid !== uuid));
        const updatedFiles = JSON.parse(localStorage.getItem("BankFile")).filter(
          (file) => file.uuid !== uuid
        );
        localStorage.setItem("BankFile", JSON.stringify(updatedFiles));
        submitSupport(updatedFiles);
        document.getElementById("file-upload").value = "";
      } else {
        setErrorMessage("Failed to delete the file.");
      }
    } catch (error) {
      console.error("Error deleting file:", error);
    }
  };

  const handleRetryUpload = (file) => {
    uploadFiles([file]);
  };

  const handleSubmit = () => {
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    onNext(5);
    onQuestion(6);
  };

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  
      useEffect(() => {
        if (audioRef.current) {
          // Update the audio source and reload the element
          audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
          audioRef.current.load();
          // If audio was playing, continue playing the new audio
          if (isPlaying) {
            audioRef.current.play();
          }
        }
      }, [selectedLang, isPlaying]);

           useEffect(() => {
               const handler = () => {
                if (audioRef.current) {
                   audioRef.current.pause();
                   audioRef.current.currentTime = 0;
                    setIsPlaying(false);
                  }
                };
                window.addEventListener('pauseAllAudio', handler);
                return () => window.removeEventListener('pauseAllAudio', handler);
              }, []);

  return (
    <div className="question">
      <div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex" }}>
            <h2>
              {translations[selectedLang].uploadTitle}
              <span style={{ color: "red" }}>*</span>
            </h2>
            <button onClick={toggleAudio} className="audio-button">
              {isPlaying ? <FaPause color="White" size={12} style={{ marginBottom: '20px' }} /> : <FaPlay color="White" size={12} style={{ marginBottom: '20px' }} />}
            </button>
          </div>
          <audio ref={audioRef} onEnded={handleAudioEnd}>
            <source src={audioMap[selectedLang]} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
          <p className="victim-para">{translations[selectedLang].uploadNote}</p>
          <input
            type="file"
            id="file-upload"
            multiple
            onChange={handleFileChange}
            className="file-input"
            style={{ display: "none" }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <label htmlFor="file-upload" className="upload-file">
              {translations[selectedLang].chooseFiles}
            </label>
            {files.length > 0 && (
              <button
                type="button"
                style={{ width: "95px", zIndex: "9" }}
                className="ok-btn"
                onClick={handleSubmit}
              >
                {isUploading
                  ? "Uploading..."
                  : `${translations[selectedLang].ok} (${files.length})`}
              </button>
            )}
          </div>
          {errorMessage && (
            <div className="error-message" style={{ color: "red", width: "50%" }}>
              {errorMessage}
            </div>
          )}
          <div className="file-preview">
            {files.length > 0 && (
              <ul>
                {files.map(({ url, uuid, name, type, status }, index) => (
                  <li key={uuid} className="file-item">
                    <div className="file-container">
                      {type === "application/pdf" ? (
                        <div className="pdf-preview">
                          <FaFilePdf size={50} color="red" />
                          <p style={{ fontSize: "8px" }}>{name}</p>
                        </div>
                      ) : (
                        <img src={url} alt={name} className="preview-image" />
                      )}
                      <button
                        type="button"
                        onClick={() => handleRemoveFile(index, uuid)}
                        className="remove-button"
                        style={{ zIndex: "9" }}
                      >
                        <RxCross2 />
                      </button>
                      {status !== "uploaded" && (
                        <div
                          className={`retry-circle ${isUploading ? "rotating" : ""}`}
                          onClick={() => handleRetryUpload({ url, uuid, name })}
                          style={{
                            position: "absolute",
                            top: "20%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "20px",
                            height: "20px",
                            backgroundColor: "red",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          <FaRedoAlt style={{ color: "white", fontSize: "14px" }} />
                        </div>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
          {answer[4] && (
            <p className="alert-box">
              {translations[selectedLang].moveError}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BankUpload;
